// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/balance_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BalanceDemandService } from "./balance_service_pb";

/**
 * @generated from rpc bffuser.v1.BalanceDemandService.GetDemandDashboard
 */
export const getDemandDashboard = BalanceDemandService.method.getDemandDashboard;

/**
 * @generated from rpc bffuser.v1.BalanceDemandService.GetDemandDetail
 */
export const getDemandDetail = BalanceDemandService.method.getDemandDetail;
